import styled from "styled-components";

export const UserManagementContainer = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
`